import Vue from "vue";
import vSelect from "vue-select";
import cartFilters from "./cart-filters";
import { getCustomCart, updateCartNote } from "./cart-requests";

function initCartOverview() {
    var el = document.getElementById("checkout-overview-app");
    if (!el) return;
    var token = el.getAttribute("data-token");
    Vue.component("v-select", vSelect);

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        filters: cartFilters,
        data: {
            loading: true,
            errors: [],
            submitting: false,
            showShippingAddress: document.getElementById("showShippingAddress")
                ? document.getElementById("showShippingAddress").checked == true
                : false,
            orderWantsInvoice: document.getElementById("orderWantsInvoice")
                ? document.getElementById("orderWantsInvoice").checked
                : false,
            cart: null,
            showEditNote: false,
            editNote: false,
            //shippingAddressId: null,
            cartErrors: null,
            deliveryCities: window.deliveryCities,
            allCities: window.allCities,
            email: document.getElementById("email") ? document.getElementById("email").value : "",
            billingAddressBusinessTaxId: document.getElementById("billingAddressBusinessTaxId")
                ? document.getElementById("billingAddressBusinessTaxId").value
                : "",
            billingAddressFirstName: document.getElementById("billingAddressFirstName").value,
            billingAddressLastName: document.getElementById("billingAddressLastName").value,
            billingAddressAddress1: document.getElementById("billingAddressAddress1").value,
            billingAddressZipCode: document.getElementById("billingAddressZipCode").value,
            billingAddressCity: document.getElementById("billingAddressCity").value,
            billingAddressPhone: document.getElementById("billingAddressPhone").value,
            // shippingAddressFirstName: document.getElementById("shippingAddressFirstName").value,
            // shippingAddressLastName: document.getElementById("shippingAddressLastName").value,
            shippingAddressAddress1: document.getElementById("shippingAddressAddress1")
                ? document.getElementById("shippingAddressAddress1").value
                : "",
            shippingAddressZipCode: document.getElementById("shippingAddressZipCode")
                ? document.getElementById("shippingAddressZipCode").value
                : "",
            shippingAddressCity: document.getElementById("shippingAddressCity")
                ? document.getElementById("shippingAddressCity").value
                : ""
            // shippingAddressCountry: document.getElementById("shippingAddressCountry").value
        },
        mounted: async function() {
            await this.loadCart();
            this.loading = false;
            console.log("cccc", this.deliveryCities);
        },
        computed: {},
        methods: {
            loadCart: async function(showLoader) {
                var result = await getCustomCart();
                this.cart = result.body.cart;
            },
            editCartNote: function(showEditNote) {
                this.showEditNote = showEditNote;
            },
            updateCartNote: async function(note) {
                this.cart.note = note;
                this.editNote = true;
                let result = await updateCartNote(token, note);
                this.editNote = false;

                if (result.body.error) {
                    this.cartErrors = result.body.errors;
                } else {
                    this.cartErrors = null;
                    this.showEditNote = false;
                }
            },
            submitCart: async function(e) {
                this.errors = [];

                var nodes = document.querySelectorAll("#checkout-overview-app :invalid");

                if (nodes.length > 0) {
                    nodes.forEach(node => {
                        this.errors.push(node.name);
                        //this[errorObjectName][node.name] = node.validationMessage;
                        // node.addEventListener("change", function(e) {
                        //     vm.validateForm();
                        // });
                    });
                }
                console.log(this.errors);
                if (!this.errors.length) {
                    this.submitting = true;
                    return true;
                }

                e.preventDefault();
            },
            hasError(n) {
                return this.errors.indexOf(n) > -1;
            },
            onChangeBillingCity: function(newValue) {
                this.billingAddressZipCode = this.allCities.filter(
                    x => x.title == newValue
                )[0].zipCode;
            },
            onChangeShippingCity: function(newValue) {
                this.shippingAddressZipCode = this.deliveryCities.filter(
                    x => x.title == newValue
                )[0].zipCode;
            }
        },
        watch: {}
    });
}
export default function init() {
    initCartOverview();
}
